import { render, staticRenderFns } from "./Schematic.vue?vue&type=template&id=9ee1964e&lang=pug&"
import script from "./Schematic.vue?vue&type=script&lang=js&"
export * from "./Schematic.vue?vue&type=script&lang=js&"
import style0 from "./Schematic.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ee1964e')) {
      api.createRecord('9ee1964e', component.options)
    } else {
      api.reload('9ee1964e', component.options)
    }
    module.hot.accept("./Schematic.vue?vue&type=template&id=9ee1964e&lang=pug&", function () {
      api.rerender('9ee1964e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/Schematic.vue"
export default component.exports